<template>
  <v-container
    fluid
    style="display: flex; flex-direction: column; height: 100vh; margin: 0; padding: 0 2%;"
  >
    <!-- Título -->
    <v-row class="section" style="flex: 0 0 5%; justify-content: center;">
      <v-col cols="12" class="text-center titulo-principal">
        {{ line?.name || `` }}
      </v-col>
    </v-row>

    <!-- Primer row de datos (porcentaje de productividad)-->
    <v-row class="section" style="flex: 0 0 10%; background-color: #e3f2fd; border-radius: 8px; padding: 10px;">
      <v-col>
        <v-row>
          <v-col cols="4" class="hover-text texto-principal" style="color: #2196F3;">
            <v-icon left>mdi-arrow-up</v-icon> % Producción turno 
          </v-col>
          <v-col cols="4" class="hover-text texto-principal" style="color: #1976D2;">
            {{ line?.register_number ? `${line?.tiempo_produccion_turno}%` : "??" }}
          </v-col>

          <v-col cols="4" class="texto-principal" style="color: black;">
            <v-icon left>mdi-chart-line</v-icon> % Producción día {{ line?.register_number ? `${line?.tiempo_produccion}%` : "??" }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Segundo row de datos (media respecto al tiempo disponible) -->
    <v-row class="section" style="flex: 0 0 5%; background-color: #f5f5f5; border-radius: 8px; padding: 10px; border-bottom: 2px solid #ccc;">
      <v-col cols="4" class="hover-text texto-principal" style="color: #D32F2F;">
        <v-icon left>mdi-speedometer</v-icon> Ciclos/minuto disponible turno  
      </v-col>
      <v-col cols="4" class="hover-text texto-principal" style="color: #1976D2;">
        {{ line.media_ciclos }}
      </v-col>

      <v-col cols="4" class="texto-principal" style="color: #D32F2F;">
        <v-icon left>mdi-speedometer</v-icon> Día {{ line.media_ciclos_disponibles }}
      </v-col>
    </v-row>

    <!-- Tercer row de datos (Acumulado de ciclos) -->
    <v-row class="section" style="flex: 0 0 5%; background-color: #f5f5f5; border-radius: 8px; padding: 10px; border-bottom: 2px solid #ccc;">
      <v-col cols="4" class="hover-text texto-principal" style="color: #2196F3;">
        <v-icon left>mdi-counter</v-icon> Ciclos acumulado turno  
      </v-col>
      <v-col cols="4" class="hover-text texto-principal" style="color: #1976D2;">
        {{ line.ciclos_totales }}
      </v-col>

      <v-col cols="4" class="texto-principal" style="color: #D32F2F;">
        <v-icon left>mdi-counter</v-icon> Día {{ line.ciclos_totales_dia }}
      </v-col>
    </v-row>

    <!-- Cuarto row de datos (Ciclos y hora)-->
    <v-row class="section" style="flex: 0 0 5%; background-color: #e3f2fd; border-radius: 8px; padding: 10px; border-bottom: 2px solid #ccc;">
      <v-col cols="4" class="hover-text texto-principal" style="color: #D32F2F;">
        <v-icon left>mdi-timer-sand</v-icon> Ciclos/minuto  
      </v-col>
      <v-col cols="4" class="hover-text texto-principal" style="color: #1976D2;">
        {{ line.ciclos }}
      </v-col>

      <v-col cols="4" class="texto-principal" style="color: black;">
        <v-icon left>mdi-clock</v-icon> Hora {{ currentHour }}
      </v-col>
    </v-row>

    <!-- Mensaje de no datos -->
    <v-row class="section" v-if="!line?.register_number" style="flex: 0 0 5%;">
      <v-col cols="12" style="color: red"> No hay datos disponibles </v-col>
    </v-row>

    <!-- Contenedor para los gráficos -->
    <v-row class="section" style="flex: 1;">
      <v-col style="height: 100%;">
        <div class="chart-wrapper">
          <div
            v-for="(statistic, statistic_index) in statistics"
            :key="statistic_index"
            class="chart-container"
          >
            <LineChart :chartData="statistic" />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import LineChart from "@/components/LineChart.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    LineChart,
  },
  data() {
    return {
      line: {},
      statistics: [],
      currentHour: moment().format("HH:mm"),
      modIDs: [7, 8],
    };
  },
  computed: {
    ...mapState("nodered", ["client"]),
    line_id() {
      return this.$route.params.line_id;
    },
    //id 7 y 8 no estan sincronizados con el numero de linea
    name_line_id() {
      if(this.modIDs.includes(this.line_id)) return this.line_id + 1;
      return this.line_id;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.updateData();
    this.doSubscribe("UPDATE");
    this.client.on("message", (topic, message) => {
      console.log("ha llegado mensaje!", topic,)
      if (topic === "UPDATE" && JSON.parse(new TextDecoder().decode(message)).update) {
        // Actualizar currentHour con la zona horaria de Madrid
        this.currentHour = moment().tz("Europe/Madrid").format("HH:mm");
        console.log("la current hour es", this.currentHour)
        this.updateData();
      }
    });

    this.handleResize(); // Ajustar tamaño cuando se monta por primera vez
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.doUnsubscribe("UPDATE");
  },
  methods: {
    ...mapActions(["getData"]),
    ...mapActions("nodered", ["doSubscribe", "doUnsubscribe"]),
    handleResize() {
      const canvas = this.$el.querySelector('.chart-container canvas');
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight * 0.6; // Ajusta el porcentaje según necesites
      }
    },
    async updateData() {
      try {
        const timestamps = this.getStartAndEndTimestamps();

        // Convertir cada timestamp de la zona horaria de Madrid a UTC
        const startTimestampUTC = moment.tz(timestamps.start_timestamp, "Europe/Madrid").utc().format("YYYY-MM-DD HH:mm:ss");
        const endTimestampUTC = moment.tz(timestamps.end_timestamp, "Europe/Madrid").utc().format("YYYY-MM-DD HH:mm:ss");

        // Crear un nuevo objeto con los timestamps ajustados a UTC
        const output = {
            start_timestamp: startTimestampUTC,
            end_timestamp: endTimestampUTC
        };
        console.log("output", output);
        const [{ line }, { statistics }] = await Promise.all([
          this.getData({ path: `production/lines/${this.line_id}`, params: output }),
          this.getData({ path: "production/lines", params: { ...output } }),
        ]);
        this.line = line;
        console.log("line",line);
        console.group("line.ciclos_turno")
        console.log(line.ciclos_turno)

        // Iterar sobre cada objeto en el array
        line.ciclos_turno.forEach((entry) => {
          entry.datasets.forEach(dataset => {
              const [start, end] = dataset.label.split(" : ");

              // Obtener la fecha actual en formato YYYY-MM-DD
              const today = moment().format("YYYY-MM-DD");

              // Convertir ambas horas a la zona horaria de Madrid
              const startMadrid = moment.utc(`${today} ${start}`, "YYYY-MM-DD HH:mm").tz("Europe/Madrid").format("HH:mm");
              const endMadrid = moment.utc(`${today} ${end}`, "YYYY-MM-DD HH:mm").tz("Europe/Madrid").format("HH:mm");

              // Asignar el nuevo valor al label en el formato "HH:mm : HH:mm"
              dataset.label = `${startMadrid} : ${endMadrid}`;
          });
          entry.datasets.splice();

          // Convertir cada fecha en labels a la zona horaria de Madrid
          entry.labels = entry.labels.map(label =>
              moment.utc(label, "YYYY-MM-DD HH:mm").tz("Europe/Madrid").format("YYYY-MM-DD HH:mm")
          );
          entry.labels.splice();
        });

        line.ciclos_turno.splice();


        console.groupEnd();
        this.statistics = line.ciclos_turno;
        //recoger el maximo para poner limite al eje y
        for (let dataset of this.statistics){
          const soloNumeros = dataset.datasets[0].data .filter(Number.isFinite)
          let val = null;
          if (soloNumeros.length > 0) val = Math.ceil(Math.max(...soloNumeros) / 5) * 5;
          dataset.max = val;
        }
        console.group("ESTADISTICAS Y LINEA");
        console.log(statistics, line);
        console.groupEnd();
        const horaActual = moment(this.getLastTime()).tz("Europe/Madrid").format("HH:mm");
        console.log("horaActual", horaActual);
        this.currentHour = horaActual;
      } catch (error) {
        console.error(`Error al recoger datos del back: ${error}`);
      }
    },
    getStartAndEndTimestamps() {
      let start_timestamp = moment();
      let end_timestamp = moment();
      const reference_shift = this.getCurrentShift();
      console.log("CURRENT SHIFT",reference_shift)

      switch (reference_shift) {
        case 1:
          start_timestamp.set({ hour: 6, minute: 0, second: 0 });
          end_timestamp.set({ hour: 13, minute: 59, second: 59 });
          break;
        case 2:
          start_timestamp.set({ hour: 14, minute: 0, second: 0 });
          end_timestamp.set({ hour: 21, minute: 59, second: 59 });
          break;
        case 3:
          start_timestamp.set({ hour: 22, minute: 0, second: 0 });
          end_timestamp.add(1, "day");
          end_timestamp.set({ hour: 5, minute: 59, second: 59 });
        
          break;
        case 4:
          start_timestamp.set({ hour: 22, minute: 0, second: 0 });
          start_timestamp.subtract(1, "day")
          end_timestamp.set({ hour: 5, minute: 59, second: 59 });
          break;
        default:
          start_timestamp.set({ hour: 6, minute: 0, second: 0 });
          end_timestamp.add(1, "day");
          end_timestamp.set({ hour: 5, minute: 59, second: 59 });
          break;
      }

      start_timestamp = start_timestamp.format("YYYY-MM-DD HH:mm:ss");
      end_timestamp = end_timestamp.format("YYYY-MM-DD HH:mm:ss");
      return { start_timestamp, end_timestamp };
    },
    getCurrentShift() {
      const reference_now_hour = moment().hour();
      console.log("reference_now_hour", reference_now_hour);

      if (reference_now_hour >= 6 && reference_now_hour < 14) return 1;
      else if (reference_now_hour >= 14 && reference_now_hour < 22) return 2;
      else if (reference_now_hour >= 22 && reference_now_hour <= 23) return 3;
      else if (reference_now_hour >= 0 && reference_now_hour < 6) return 4;
    },
    getLastTime() {
      let lastTime = null;
      const dataGrafico1 = this.statistics[0].datasets[0].data;
      const hoursGrafico1 = this.statistics[0].labels;

      if(dataGrafico1[dataGrafico1.length-1] === null){
        for (let index = 0; index < dataGrafico1.length; index++) {
          const element = dataGrafico1[index];
          if(element !== null) lastTime = hoursGrafico1[index];
        }
        return lastTime;
      }
      const dataGrafico2 = this.statistics[1].datasets[0].data;
      const hoursGrafico2 = this.statistics[1].labels;
      for (let index = 0; index < dataGrafico2.length; index++) {
        const element = dataGrafico2[index];
        if(element !== null) lastTime = hoursGrafico2[index];
      }
      return lastTime;
    }
  },
  async mounted() {
    this.updateData();
    this.doSubscribe("UPDATE");
    this.client.on("message", (topic, message) => {
      if (topic === "UPDATE" && JSON.parse(new TextDecoder().decode(message)).update) {
        console.log("message", message)
        this.updateData();
      }
    });
  },
  beforeDestroy() {
    this.doUnsubscribe("UPDATE");
  },
};
</script>
<style scoped>
/* Para pantallas grandes */
.titulo-principal {
  font-size: 5vw; /* Basado en el ancho para pantallas grandes */
  font-weight: bold;
  color: #333;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

/* Para dispositivos móviles en modo vertical (portrait) */
@media only screen and (orientation: portrait) {
  .titulo-principal {
    font-size: 3vh; /* Basado en la altura cuando está en vertical */
  }
  .texto-principal {
    font-size: 2vh; /* Basado en la altura para el texto en vertical */
  }
}

/* Para dispositivos móviles en modo horizontal (landscape) */
@media only screen and (orientation: landscape) {
  .titulo-principal {
    font-size: 3vw; /* Basado en la anchura cuando está en horizontal */
  }
  .texto-principal {
    font-size: 2vw; /* Basado en la anchura para el texto en horizontal */
  }
}
.chart-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%; /* Mantén esta regla */
}

.chart-container {
  flex: 1; /* Deja que el gráfico ocupe todo el espacio disponible */
  width: 100%; /* Ocupará todo el ancho disponible */
  max-height: 100%; /* Asegúrate de que no supere la altura disponible */
}

.chart-container canvas {
  height: 100% !important; /* Asegura que el gráfico se ajuste al contenedor */
  width: 100% !important;
  box-sizing: border-box;
}
</style>
